import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
import { Button } from '../components/ui/Button';
import { CalendarIcon, ClockIcon, ScissorsIcon } from 'lucide-react';
export function BookingPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <>
      <PageBanner title="Book Your Appointment" subtitle="Reserve your time with our master braiders." backgroundImage="https://cdn.magicpatterns.com/uploads/2Rg35apmrhiBC7SirPQpSB/istockphoto-183341611-612x612.webp" data-id="element-288" />

      <section className="py-24 bg-cream relative" data-id="element-289">
        <div className="absolute inset-0 pattern-dots opacity-10" data-id="element-290"></div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-291">
          <div className="bg-white rounded-sm shadow-xl overflow-hidden border border-brown/10" data-id="element-292">
            <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-293">
              {/* Info Sidebar */}
              <div className="bg-jet text-cream p-8 md:p-10 flex flex-col justify-between" data-id="element-294">
                <div data-id="element-295">
                  <h3 className="text-2xl font-heading font-bold text-golden mb-6" data-id="element-296">
                    Booking Policies
                  </h3>
                  <ul className="space-y-6 text-sm text-cream/80" data-id="element-297">
                    <li className="flex gap-3" data-id="element-298">
                      <ClockIcon className="w-5 h-5 text-golden shrink-0" data-id="element-299" />
                      <span data-id="element-300">
                        Please arrive 10 minutes before your scheduled
                        appointment time.
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-301">
                      <ScissorsIcon className="w-5 h-5 text-golden shrink-0" data-id="element-302" />
                      <span data-id="element-303">
                        Hair must be washed, detangled, and blow-dried prior to
                        arrival unless adding a wash service.
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-304">
                      <CalendarIcon className="w-5 h-5 text-golden shrink-0" data-id="element-305" />
                      <span data-id="element-306">
                        A $50 non-refundable deposit is required to secure your
                        slot.
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="mt-12 pt-8 border-t border-cream/20" data-id="element-307">
                  <p className="text-sm text-cream/60 italic" data-id="element-308">
                    "Your hair is your crown. We can't wait to help you wear it
                    with pride."
                  </p>
                </div>
              </div>

              {/* Form Area */}
              <div className="p-8 md:p-10 md:col-span-2 bg-white" data-id="element-309">
                {isSuccess ? <motion.div initial={{
                opacity: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                scale: 1
              }} className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-310">
                    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-311">
                      <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-312">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-313"></path>
                      </svg>
                    </div>
                    <h3 className="text-3xl font-heading font-bold text-jet mb-4" data-id="element-314">
                      Request Received!
                    </h3>
                    <p className="text-brown mb-8 max-w-md" data-id="element-315">
                      Thank you for choosing Beni's African Hair Braiding. We've
                      received your booking request and will contact you shortly
                      to confirm your appointment and collect the deposit.
                    </p>
                    <Button variant="outline" onClick={() => setIsSuccess(false)} data-id="element-316">
                      Book Another Service
                    </Button>
                  </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-317">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-318">
                      <div className="space-y-2" data-id="element-319">
                        <label htmlFor="firstName" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-320">
                          First Name
                        </label>
                        <input type="text" id="firstName" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all" placeholder="Jane" data-id="element-321" />
                      </div>
                      <div className="space-y-2" data-id="element-322">
                        <label htmlFor="lastName" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-323">
                          Last Name
                        </label>
                        <input type="text" id="lastName" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all" placeholder="Doe" data-id="element-324" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-325">
                      <div className="space-y-2" data-id="element-326">
                        <label htmlFor="email" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-327">
                          Email Address
                        </label>
                        <input type="email" id="email" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all" placeholder="jane@example.com" data-id="element-328" />
                      </div>
                      <div className="space-y-2" data-id="element-329">
                        <label htmlFor="phone" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-330">
                          Phone Number
                        </label>
                        <input type="tel" id="phone" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all" placeholder="301-710-6221" data-id="element-331" />
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-332">
                      <label htmlFor="service" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-333">
                        Select Service
                      </label>
                      <select id="service" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all appearance-none" data-id="element-334">
                        <option value="" data-id="element-335">Choose a style...</option>
                        <option value="knotless" data-id="element-336">
                          Knotless Braids (From $180)
                        </option>
                        <option value="box" data-id="element-337">Box Braids (From $150)</option>
                        <option value="cornrows" data-id="element-338">Cornrows (From $80)</option>
                        <option value="goddess" data-id="element-339">
                          Goddess Braids (From $165)
                        </option>
                        <option value="faux-locs" data-id="element-340">Faux Locs (From $200)</option>
                        <option value="twists" data-id="element-341">
                          Senegalese Twists (From $160)
                        </option>
                        <option value="other" data-id="element-342">Other / Consultation</option>
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-343">
                      <div className="space-y-2" data-id="element-344">
                        <label htmlFor="date" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-345">
                          Preferred Date
                        </label>
                        <input type="date" id="date" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all" data-id="element-346" />
                      </div>
                      <div className="space-y-2" data-id="element-347">
                        <label htmlFor="time" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-348">
                          Preferred Time
                        </label>
                        <select id="time" required className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all appearance-none" data-id="element-349">
                          <option value="" data-id="element-350">Choose a time...</option>
                          <option value="morning" data-id="element-351">Morning (9AM - 12PM)</option>
                          <option value="afternoon" data-id="element-352">
                            Afternoon (12PM - 4PM)
                          </option>
                          <option value="evening" data-id="element-353">Evening (4PM - 7PM)</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-354">
                      <label htmlFor="notes" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-355">
                        Additional Notes
                      </label>
                      <textarea id="notes" rows={4} className="w-full px-4 py-3 bg-beige/30 border border-brown/20 rounded-sm focus:outline-none focus:ring-2 focus:ring-golden focus:border-transparent transition-all resize-none" placeholder="Tell us about your hair length, density, or any specific requests..." data-id="element-356"></textarea>
                    </div>

                    <Button type="submit" variant="primary" size="lg" className="w-full" disabled={isSubmitting} data-id="element-357">
                      {isSubmitting ? 'Processing...' : 'Request Appointment'}
                    </Button>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}